import React from 'react'
import CardContent from "@mui/material/CardContent"
import Box from "@mui/material/Box"
import CardActions from "@mui/material/CardActions"
import Button from "@mui/material/Button"
import Card from "@mui/material/Card"
import {useSelector} from "react-redux"
import {STRIPE_CLIENT_SECRET, STRIPE_CUSTOMER_ID, STRIPE_PRICE_ID} from "../../../config/constants"
import {useDispatch} from "react-redux"
import {setOpen, setPriceId} from "../ProductDialog/slice"
import {useMutation} from "@apollo/client";
import {ADD_SETUP_INTENT} from "../../widgets/PriceTable/graphql";
import {setUser} from "../../../slice";
import {useNavigate} from "react-router-dom"

function  ProductItem(props) {

    const {title, description, price, interval, priceId} = props
    const user = useSelector(state => state.global.user)
    const customerId = (user.stripeCustomerId) ? user.stripeCustomerId : ""
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [addSetupIntent, {loading}] = useMutation(ADD_SETUP_INTENT, {
        variables: {
            priceId,
            customerId: user.stripeCustomerId
        },
        onCompleted: ({addSetupIntent}) => {
            if (addSetupIntent?.result?.status === 'success') {
                const stripeClientSecret = addSetupIntent.result.clientSecret
                const stripeCustomerId = addSetupIntent.result.customerId
                sessionStorage.setItem(STRIPE_CLIENT_SECRET, stripeClientSecret)
                localStorage.setItem(STRIPE_CUSTOMER_ID, stripeCustomerId)
                dispatch(setUser({
                    ...user,
                    stripeClientSecret,
                    stripeCustomerId
                }))
                navigate('/trial')
            }else if (addSetupIntent?.result?.status === 'error') {
                console.error(`[ERROR CREATING SETUP INTENT]: ${addSetupIntent.result.message}`)
            }else if (addSetupIntent?.errors) {
                console.error(`[FAILURE CREATING SETUP INTENT]: ${JSON.stringify(addSetupIntent.errors)}`)
            }
        }
    })

    const handlePriceSelection = (priceId) => {
        if (user.subscribed === true) {
            dispatch(setPriceId(priceId))
            dispatch(setOpen(true))
        } else {
            dispatch(setPriceId(priceId))
            sessionStorage.setItem(STRIPE_PRICE_ID, priceId)
            if (user.authenticated && user.subscribed !== true) {
                addSetupIntent({
                        variables: {
                            priceId,
                            customerId
                        }
                    }
                )
            } else {
                navigate('/signup')
            }
        }
    }

    return (
        <Card className="text-center">
            <CardContent sx={{minHeight: {md: '225px'}, px: 5}}>
                <h2>{title}</h2>
                <Box my={2}>
                    <h3 style={{lineHeight: 0.8}}>${price}</h3>
                    <h6 style={{marginTop: 0}}>every {interval}</h6>
                </Box>
                <h6>{description}</h6>
            </CardContent>
            <CardActions sx={{justifyContent: "center"}}>
                {(priceId === user.stripePriceId && user.subscribed === true) ?
                    <div><strong>This is your current plan</strong></div>
                    :
                    <Button
                        variant="contained"
                        sx={{margin: "auto", mb: 4}}
                        onClick={() => {
                            handlePriceSelection(priceId)
                        }}
                        disabled={loading}
                    >Select</Button>
                }

            </CardActions>
        </Card>
    )
}

export default ProductItem